import { render, staticRenderFns } from "./activar_desactivar_autoridades_institucion.vue?vue&type=template&id=3965d3cb"
import script from "./activar_desactivar_autoridades_institucion.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_autoridades_institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports